var exports = {
  "kL": "x61f99309--3be42c--container",
  "Qq": "x61f99309--3be42c--text",
  "fP": "x61f99309--3be42c--attention",
};

module.exports = exports;
